import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to balance risk with potential benefits.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>Compete or collaborate?</p>
                                            <div className="border_subtitle">Balancing risk</div>
                                            <p>There are some of us who are born competitors, whilst others
                                                are all about cooperation and consensus; most of us are
                                                somewhere in between. This is related to our innate sense of
                                                whether to run away or to stay and work through the
                                                situation – the fight or flight response.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a> Although
                                                we can be naturally competitive or collaborative, we often
                                                adapt our approach through our experience. A well known
                                                piece of psychological research conducted in the 1960s<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a> aimed
                                                to show how experience enables us to learn to respond
                                                differently to situations.</p>

                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">The prisoner’s dilemma
                                                </div>
                                                <p>Consider this issue: Detectives interview two prisoners
                                                    separately and afterwards decide that there is only
                                                    adequate evidence to convict them for a lesser offence.
                                                    The police separately offer these individuals the
                                                    opportunity to confess. However, if one confesses and
                                                    the other does not then the confessor will have immunity
                                                    and the evidence will be used to convict the other
                                                    individual on the more serious offence. If both confess,
                                                    both get the lighter sentence, and if neither confesses
                                                    then the sentence will be very light.</p>
                                                <p className="cntareap"
                                                   style={{paddingBottom:'0px !important'}}>The prisoner’s
                                                    dilemma creates a matrix. Mutual silence is the best
                                                    shared outcome for the prisoners, yet a degree of
                                                    suspicion and lack of trust can often lead to a
                                                    confession from both parties. This study has been
                                                    duplicated with hundreds of prisoners and it seems that
                                                    people are torn between competing with one another and
                                                    cooperating, as their fate rests on both people’s
                                                    choices.</p>


                                            </div>
                                            <br/><br/>
                                            <p className="tablelft separator">Prisoner A</p>

                                            <img className="imgthg"
                                                 src={require('@images/thought_PrisonerB.png')}
                                                 alt=""/>
                                            <div className="desktop ipad-portrait-show">
                                                <table width="90%" cellSpacing="0" cellPadding="0"
                                                       border="0" className="ilead_v_sport">
                                                    <tbody>
                                                    <tr>
                                                        <th width="15%" valign="top" align="left"
                                                            className="green_curve"></th>
                                                        <th width="15%" valign="top" align="left"
                                                            colSpan="2">Confesses
                                                        </th>
                                                        <th width="15%" valign="top" align="left"
                                                            className="green_curve1"
                                                            colSpan="2">Does not confess
                                                        </th>
                                                    </tr>

                                                    <tr>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen1">Confesses
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">3 years
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">3 years
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">0 years
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 years
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen1">Does not confess
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 years
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">0 years
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 months
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 months
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile ipad-portrait-hide">
                                                <table width="80%" border="0" cellSpacing="0"
                                                       cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve"
                                                            width="50%"></th>
                                                        <th className="darkgreen" valign="top"
                                                            style={{borderTopRightRadius:'15px'}}>Confesses
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable"
                                                            style={{borderTopLeftRadius:'0px'}}
                                                            rowSpan="2">Confesses
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">3 years
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">3 years
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable"
                                                            style={{borderBottomLeftRadius:'15px'}}
                                                            rowSpan="2">Does not confess
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">0 years
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="10%" valign="top">6
                                                            years
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve"
                                                            width="50%"></th>
                                                        <th className="darkgreen"
                                                            style={{borderTopRightRadius: '15px'}}>Does
                                                            not confess
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable"
                                                            style={{borderTopLeftRadius:'0px'}}
                                                            rowSpan="2">Confesses
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 years
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">0 years
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable"
                                                            style={{borderBottomLeftRadius:'15px'}}
                                                            rowSpan="2">Does not confess
                                                        </td>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 months
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="10%" valign="top" align="left"
                                                            className="darkgreen">6 months
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}